import PendingQueries from './PendingQueries';
import createPendingQueriesLink from './PendingQueriesLink';

/* Store pending queries as an array of strings */
const typeDefs = `
  type Query {
    pendingQueries: [String!]!
  }
`;

export { createPendingQueriesLink as createLink, typeDefs };

export default PendingQueries;
